import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 136.7 122.7",
  style: {"enable-background":"new 0 0 136.7 122.7"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { type: "text/css" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".__st0{fill:#010101}.__st1{fill:#FFFFFF}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("g", null, [
      _createElementVNode("g", null, [
        _createElementVNode("path", { d: "M68.5,116.6c-30.9,0-56-25.1-56-56s25.1-56,56-56s56,25.1,56,56S99.4,116.6,68.5,116.6z M68.5,10.6c-27.6,0-50,22.4-50,50\n\t\t\ts22.4,50,50,50s50-22.4,50-50S96.1,10.6,68.5,10.6z" })
      ]),
      _createElementVNode("path", {
        class: "__st0",
        d: "M78.4,56H65.3v13.1h6.6v-9.8h6.6v16.4H65.3c-3.6,0-6.6-2.9-6.6-6.6V56c0-3.6,2.9-6.6,6.6-6.6h13.1V56z\n\t\t M68.5,29.7c1.7,0,3.4,0.7,4.6,1.9c1.2,1.2,1.9,2.9,1.9,4.6c0,1.7-0.7,3.4-1.9,4.6c-1.2,1.2-2.9,1.9-4.6,1.9s-3.4-0.7-4.6-1.9\n\t\tC62.7,39.7,62,38,62,36.3c0-1.7,0.7-3.4,1.9-4.6C65.1,30.4,66.8,29.7,68.5,29.7z M94.6,48c-0.7-2.9-3.3-5.1-6.4-5.1h-8.3\n\t\tc1.1-1.9,1.8-4.2,1.8-6.6c0-3.5-1.4-6.8-3.8-9.3c-2.5-2.5-5.8-3.8-9.3-3.8s-6.8,1.4-9.3,3.8c-2.5,2.5-3.8,5.8-3.8,9.3\n\t\tc0,2.4,0.6,4.6,1.8,6.6h-8.3c-3.1,0-5.7,2.2-6.4,5.1c-6.6,26.3-6.7,26.9-6.7,27.7c0,1.7,0.7,3.4,1.9,4.6c1.2,1.2,2.9,1.9,4.6,1.9\n\t\th52.4c1.7,0,3.4-0.7,4.6-1.9c1.2-1.2,1.9-2.9,1.9-4.6C101.3,74.9,101.2,74.2,94.6,48z"
      })
    ], -1))
  ]))
}
export default { render: render }